<ion-row class="title-section skeleton" *ngIf="isLoading">
  <ion-col>
    <ion-skeleton-text animated></ion-skeleton-text>
  </ion-col>
  <ion-col>
    <ion-skeleton-text animated></ion-skeleton-text>
  </ion-col>
  <ion-skeleton-text animated></ion-skeleton-text>
</ion-row>
<ion-row class="title-section" *ngIf="!isLoading">
  <h5
    [ngClass]="{
      'is-tablet':
        platformService?.platformType === platformService?.platformEnum.tablet,
    }"
    data-cy="payment-title"
  >
    {{
      (isSubmitted
        ? 'i18n.payments.paymentConfirmation.paymentItems'
        : 'i18n.payments.reviewAndSubmit.paymentDetails'
      ) | translate
    }}
  </h5>
  <h5
    [ngClass]="{
      'is-tablet':
        platformService?.platformType === platformService?.platformEnum.tablet,
    }"
    class="total-amount"
  >
    <span class="total-amount__title" data-cy="total-amount-title">{{
      'i18n.payments.reviewAndSubmit.totalAmount' | translate
    }}</span>
    <span data-cy="total-amount">&nbsp;{{ totalAmount | currency }}</span>
  </h5>
</ion-row>

<ion-row class="customer-summary skeleton" *ngIf="isLoading">
  <ion-skeleton-text animated></ion-skeleton-text>
  <ion-skeleton-text animated></ion-skeleton-text>
  <ion-skeleton-text animated></ion-skeleton-text>
  <ion-skeleton-text animated></ion-skeleton-text>
  <ion-skeleton-text animated></ion-skeleton-text>
</ion-row>
<ion-row class="customer-summary" *ngIf="!isLoading">
  <ion-accordion-group
    [animated]="false"
    [multiple]="true"
    [value]="accordionValues"
  >
    <ion-accordion
      *ngFor="let customer of customers; let i = index"
      [class.is-submitted]="isSubmitted"
      [class.hide-chevron]="customer.isAllAutoPay"
      [value]="customer.customerNumber"
      [readonly]="customer.isAllAutoPay"
    >
      <ion-item slot="header" class="gray-content-bg">
        <section
          [class.is-mobile]="
            platformService?.platformType ===
            platformService?.platformEnum.mobile
          "
          [class.is-tablet]="
            platformService?.platformType ===
            platformService?.platformEnum.tablet
          "
        >
          <ion-grid>
            <ion-row>
              <ion-col
                size-xs="12"
                size-lg="4"
                size-md="4"
                size-xs="12"
                class="customer-info"
                [class.disabled]="customer.isAllAutoPay"
                [attr.data-cy]="'customer-label-' + i"
              >
              </ion-col>
            </ion-row>
            <ion-row *ngIf="customer.isAllAutoPay">
              <ion-col
                size-lg="4"
                size-md="4"
                size-xs="12"
                class="customer-info"
                [class.disabled]="true"
                [attr.data-cy]="'customer-label-' + i"
              >
                <span
                  class="customer-name"
                  [attr.data-cy]="'customer-name-' + i"
                  >{{ customer.customerName | titlecase }}</span
                >
                <span [attr.data-cy]="'customer-number-' + i"
                  >#{{ customer.customerNumber }}</span
                ></ion-col
              >
              <ion-col
                size-lg="4"
                size-md="5"
                size-xs="12"
                class="autopay-selected"
                [attr.data-cy]="'customer-label-' + i"
              >
                <span class="alert-message">
                  <ion-icon name="alert-circle-outline"></ion-icon>
                  {{
                    'i18n.payments.reviewAndSubmit.autopaySelected' | translate
                  }}
                </span>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="!customer.isAllAutoPay">
              <ion-col
                class="customer-info"
                size-md="4"
                size-lg="4"
                size-xs="12"
                [attr.data-cy]="'customer-label-' + i"
              >
                <span
                  class="customer-name"
                  [attr.data-cy]="'customer-name-' + i"
                  >{{ customer.customerName | titlecase }}</span
                >
                <span [attr.data-cy]="'customer-number-' + i"
                  >#{{ customer.customerNumber }}</span
                ></ion-col
              >
              <ion-col
                size-md="5"
                size-lg="4"
                size-xs="12"
                class="bank-info"
                [class.is-disabled]="isSubmitted || !isBanksEditable"
                [attr.data-cy]="'bank-label-' + i"
              >
                <a
                  href="javascript:void(0)"
                  [attr.data-cy]="
                    !customer.selectedBankAccount
                      ? 'add'
                      : 'change' + '-bank-account-link-' + i
                  "
                  (click)="openAddBankAccountModal($event, customer)"
                  data-private
                  >{{
                    !customer.selectedBankAccount
                      ? ('i18n.payments.reviewAndSubmit.addBankAccount'
                        | translate)
                      : (customer.selectedBankAccount.nickName
                          ? customer.selectedBankAccount.nickName
                          : customer.selectedBankAccount.bankName) +
                        ' *****' +
                        customer.selectedBankAccount.last4AccountNumber +
                        (isSubmitted
                          ? ''
                          : ' - ' + ('i18n.common.change' | translate))
                  }}</a
                >
              </ion-col>
              <ion-col
                size-md="3"
                size-lg="4"
                size-xs="6"
                class="customer-total"
                [class.border-left-black]="customers.length > 1"
                [attr.data-cy]="'customer-label-' + i"
              >
                <ng-container *ngIf="customers.length > 1">
                  <span>
                    {{
                      (isSubmitted &&
                      platformService?.platformType ===
                        platformService?.platformEnum.mobile
                        ? 'i18n.payments.reviewAndSubmit.custTotal'
                        : 'i18n.payments.reviewAndSubmit.customerTotal'
                      ) | translate
                    }}
                  </span>
                  &nbsp;
                  <span [attr.data-cy]="'customer-value-' + i">{{
                    calcTotalAmountByCustomer(customer.transactions) | currency
                  }}</span>
                </ng-container>
              </ion-col>
              <ion-col
                class="amount-items"
                size-md="4"
                size-xs="6"
                *ngIf="!isSubmitted"
                [attr.data-cy]="'amount-items-label-' + i"
                ><span>
                  {{
                    'i18n.payments.reviewAndSubmit.numberOfItems' | translate
                  }}
                </span>
                &nbsp;
                <span [attr.data-cy]="'amount-items-value-' + i">{{
                  customer.transactions.length
                }}</span></ion-col
              >
            </ion-row>
          </ion-grid>
        </section>
      </ion-item>
      <div
        *ngIf="!customer.isAllAutoPay"
        class="gray-content-bg accordion-content"
        slot="content"
        [attr.data-cy]="'details-container-' + i"
      >
        <ng-container
          *ngIf="
            platformService?.platformType ===
              platformService?.platformEnum.desktop;
            else touch
          "
        >
          <ion-row class="header-row" [attr.data-cy]="'header-row-' + i">
            <ion-col
              [size]="this.columnSizes[ColumnNames.TransactionInformation]"
              class="customer-column"
              data-cy="transaction-column-transaction"
            >
              {{
                'i18n.payments.recentInvoicesCredits.transaction' | translate
              }}
            </ion-col>
            <ion-col
              [size]="this.columnSizes[ColumnNames.PoNumber]"
              class="customer-column"
              data-cy="transaction-column-cust-po"
            >
              {{ 'i18n.payments.recentInvoicesCredits.custPo' | translate }}
            </ion-col>
            <ion-col
              *ngIf="showOrderNumber"
              [size]="this.columnSizes[ColumnNames.OrderNumber]"
              class="customer-column"
              data-cy="transaction-column-order-number"
            >
              {{
                'i18n.payments.recentInvoicesCredits.orderNumber' | translate
              }}
            </ion-col>
            <ion-col
              [size]="this.columnSizes[ColumnNames.IssueDate]"
              class="customer-column"
              data-cy="transaction-column-issue-date"
            >
              {{ 'i18n.payments.recentInvoicesCredits.issueDate' | translate }}
            </ion-col>
            <ion-col
              [size]="this.columnSizes[ColumnNames.Amount]"
              class="customer-column"
              data-cy="transaction-column-amount"
            >
              {{ 'i18n.payments.recentInvoicesCredits.amount' | translate }}
            </ion-col>
            <ion-col
              [size]="this.columnSizes[ColumnNames.AmountDue]"
              class="customer-column"
              data-cy="transaction-column-amount-due"
            >
              {{ 'i18n.payments.recentInvoicesCredits.amountDue' | translate }}
            </ion-col>
            <ion-col
              [size]="this.columnSizes[ColumnNames.DueDate]"
              class="customer-column"
              data-cy="transaction-column-due-date"
            >
              {{ 'i18n.payments.recentInvoicesCredits.dueDate' | translate }}
            </ion-col>
            <ion-col
              [size]="this.columnSizes[ColumnNames.PaymentAmount]"
              class="customer-column"
              data-cy="transaction-column-payment-amount"
            >
              {{ 'i18n.payments.transactionRow.paymentAmount' | translate }}
            </ion-col>
          </ion-row>
          <ng-container
            *ngFor="
              let transaction of customer.transactions;
              let i = index;
              trackBy: trackByIdx
            "
          >
            <app-transaction-row-desktop
              *ngIf="!transaction.hasError"
              [vm]="transaction"
              [browserDimensions]="platformService.getBrowserDimensions()"
              [isMobile]="isMobile"
              [isReview]="true"
              [isTouch]="isTouch$ | async"
              [translatorText]="transactionRowText"
              [shouldShowButtons]="isSubmitted"
              [showFullPO]="showFullPO"
              [showOrderNumber]="showOrderNumber"
              [columnSizes]="columnSizes"
              [maxPOCharLimit]="15"
              (poClickEmitter)="poNumberClicked()"
              (viewInvoiceClickEmitter)="viewInvoice($event)"
              (moreOptionsClickEmitter)="openMoreOptions($event)"
            ></app-transaction-row-desktop>
          </ng-container>
          <div
            class="autopay-transactions"
            *ngIf="customer.autoPayTransactions.length > 0"
          >
            <span class="alert-message">
              <ion-icon name="alert-circle-outline"></ion-icon>
              {{
                'i18n.payments.reviewAndSubmit.transactionsBelowAreAutopay'
                  | translate
              }}
            </span>
            <ng-container
              *ngFor="
                let transaction of customer.autoPayTransactions;
                let i = index;
                trackBy: trackByIdx
              "
            >
              <app-transaction-row-desktop
                *ngIf="!transaction.hasError"
                [vm]="transaction"
                [browserDimensions]="platformService.getBrowserDimensions()"
                [isMobile]="isMobile"
                [isReview]="true"
                [isTouch]="isTouch$ | async"
                [translatorText]="transactionRowText"
                [shouldShowButtons]="isSubmitted"
                [showFullPO]="showFullPO"
                [showOrderNumber]="showOrderNumber"
                [columnSizes]="columnSizes"
                (poClickEmitter)="poNumberClicked()"
                (viewInvoiceClickEmitter)="viewInvoice($event)"
                (moreOptionsClickEmitter)="openMoreOptions($event)"
              ></app-transaction-row-desktop>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #touch>
          <app-transaction-row-touch
            *ngFor="
              let transaction of customer.transactions;
              let i = index;
              trackBy: trackByIdx
            "
            [vm]="transaction"
            [isMobile]="isMobile"
            [isReview]="true"
            [translatorText]="transactionRowText"
            [shouldShowButtons]="isSubmitted"
            (viewInvoiceClickEmitter)="viewInvoice($event)"
            (moreOptionsClickEmitter)="openMoreOptions($event)"
          ></app-transaction-row-touch>

          <div
            class="autopay-transactions"
            *ngIf="customer.autoPayTransactions.length > 0"
          >
            <span class="alert-message">
              <ion-icon name="alert-circle-outline"></ion-icon>
              {{
                'i18n.payments.reviewAndSubmit.transactionsBelowAreAutopay'
                  | translate
              }}
            </span>
            <app-transaction-row-touch
              *ngFor="
                let transaction of customer.autoPayTransactions;
                let i = index;
                trackBy: trackByIdx
              "
              [vm]="transaction"
              [isMobile]="isMobile"
              [isReview]="true"
              [translatorText]="transactionRowText"
              [shouldShowButtons]="isSubmitted"
              (viewInvoiceClickEmitter)="viewInvoice($event)"
              (moreOptionsClickEmitter)="openMoreOptions($event)"
            ></app-transaction-row-touch>
          </div>
        </ng-template>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</ion-row>
